import Vue       from 'vue'
import Router    from 'vue-router'
import axios     from 'axios'
import VueAxios  from 'vue-axios'
import Notifications from 'vue-notification'
import responderView from '@/components/View_Responder'

Vue.use(Router)
Vue.use(VueAxios, axios)
Vue.use(Notifications)
Vue.use(require('@websanova/vue-upload'))
Vue.axios.defaults.baseURL = process.env.API_ROUTE

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'responder',
      component: responderView
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/admin.js